export const ACCESS_CONTROL_ROLE_NAMES = [
  { label: 'Owner', value: 'OWNER' },
  { label: 'Creator', value: 'CREATOR' },
  { label: 'Manager', value: 'MANAGER' },
  { label: 'Goal User', value: 'GOAL_USER' },
  { label: 'Goal Admin', value: 'GOAL_ADMIN' },
  { label: 'Collaborator', value: 'COLLABORATOR' },
  { label: 'Owners + respective managers', value: 'OWNER_MANAGER' },
  { label: 'Custom Admin', value: 'GOAL_CUSTOM_ADMIN' },
  { label: 'Collaborators + respective Managers', value: 'COLLABORATOR_MANAGER' },
];

export const ACCESS_CONTROL_ROLE_NAMES_MAP = {
  OWNER: { label: 'Owner', value: 'OWNER' },
  CREATOR: { label: 'Creator', value: 'CREATOR' },
  MANAGER: { label: 'Managers', value: 'MANAGER' },
  GOAL_USER: { label: 'Everyone', value: 'GOAL_USER' },
  GOAL_ADMIN: { label: 'Goal Admins', value: 'GOAL_ADMIN' },
  COLLABORATOR: { label: 'Collaborator', value: 'COLLABORATOR' },
  OWNER_MANAGER: { label: 'Owners + respective managers', value: 'OWNER_MANAGER' },
  GOAL_CUSTOM_ADMIN: { label: 'Custom Admins', value: 'GOAL_CUSTOM_ADMIN' },
  COLLABORATOR_MANAGER: {
    label: 'Collaborators + respective Managers',
    value: 'COLLABORATOR_MANAGER',
  },
};

export const OBJECTIVE_TYPE = [
  {
    label: 'Simple',
    value: 'SIMPLE',
    description:
      'Objectives can be created with just a title and alignment, the creator would be the owner of the objective.',
  },
  {
    label: 'Compact',
    value: 'COMPACT',
    description:
      'Objectives can have a configurable set of owners and collaborators in addition to the title and alignment.',
  },
  {
    label: 'Detailed',
    value: 'DETAILED',
    description:
      'Objectives can be tracked by setting up metrics in addition to the title, alignment and ownership information',
  },
  {
    label: 'Disabled',
    value: 'DISABLED',
    description: 'Objectives cannot be created. The goals of the organisation would be driven solely by key results.',
  },
];

export const DEFAULT_OBJECTIVE_VISIBILITY = [
  { label: 'Public', value: 'PUBLIC' },
  { label: 'Private', value: 'PRIVATE' },
];
export const DEFAULT_KR_VISIBILITY = [
  { label: 'Public', value: 'PUBLIC' },
  { label: 'Private', value: 'PRIVATE' },
];
export const DEFAULT_KR_PROGRESS = [
  {
    label: 'Dependent',
    value: 'DERIVED_AVG',
    description: 'Calculated as the arithmetic mean of progress made in all child goals',
  },
  {
    label: 'Independent',
    value: 'MANUAL',
    description: 'Calculated independently as per values set by the user',
  },
  // { label: 'Tracked', value: 'TRACKED' }
];
export const DEFAULT_OBJECTIVE_PROGRESS = [
  {
    label: 'Dependent',
    value: 'DERIVED_AVG',
    description: 'Calculated as the arithmetic mean of progress made in all child goals',
  },
  {
    label: 'Independent',
    value: 'MANUAL',
    description: 'Calculated independently as per values set by the user',
  },
  // { label: 'Tracked', value: 'TRACKED' }
];

// ACCESS CONTROL

export const OBJECTIVE_LEVEL_OPTIONS = [
  {
    label: 'Individual',
    value: 'CREATE_OBJECTIVE_INDIVIDUAL',
  },
  {
    label: 'Team',
    value: 'CREATE_OBJECTIVE_TEAM',
  },
  {
    label: 'Department',
    value: 'CREATE_OBJECTIVE_DEPARTMENT',
  },
  {
    label: 'Company',
    value: 'CREATE_OBJECTIVE_COMPANY',
  },
];

export const OBJECTIVE_LEVELS_OPTIONS_MAP = {
  CREATE_OBJECTIVE_INDIVIDUAL: {
    label: 'Individual',
    value: 'CREATE_OBJECTIVE_INDIVIDUAL',
  },
  CREATE_OBJECTIVE_TEAM: {
    label: 'Team',
    value: 'CREATE_OBJECTIVE_TEAM',
  },
  CREATE_OBJECTIVE_DEPARTMENT: {
    label: 'Department',
    value: 'CREATE_OBJECTIVE_DEPARTMENT',
  },
  CREATE_OBJECTIVE_COMPANY: {
    label: 'Company',
    value: 'CREATE_OBJECTIVE_COMPANY',
  },
};

export const CREATE_KEY_RESULT_OPTIONS = [
  {
    label: 'Parent Non-mandatory',
    value: 'CREATE_GOAL_PARENT_NON_MANDATORY',
  },
  {
    label: 'Parent mandatory',
    value: 'CREATE_GOAL_PARENT_MANDATORY',
  },
  {
    label: 'None',
    value: '',
  },
];

export const CREATE_INITIATIVE_OPTIONS = [
  {
    label: 'Yes',
    value: 'CREATE_INITIATIVES',
  },
  {
    label: 'No',
    value: '',
  },
];

export const NEW_DEFAULT_TEMPLATE = {
  name: 'OKR - Simplified',
  type: 'CUSTOM',
  moduleName: 'Goal',
  objectivesName: 'Objective',
  keyResultsName: 'Key result',
  configData: {
    OBJECTIVE_TYPE: {
      configuration: 'OBJECTIVE_TYPE',
      value: 'SIMPLE',
    },
    DEFAULT_KR_PROGRESS: {
      configuration: 'DEFAULT_KR_PROGRESS',
      value: 'MANUAL',
    },
    DEFAULT_KR_VISIBILITY: {
      configuration: 'DEFAULT_KR_VISIBILITY',
      value: 'PUBLIC',
    },
    IS_KR_CASCADING_ENABLED: {
      configuration: 'IS_KR_CASCADING_ENABLED',
      value: 'FALSE',
    },
    DEFAULT_OBJECTIVE_PROGRESS: {
      configuration: 'DEFAULT_OBJECTIVE_PROGRESS',
      value: 'DERIVED',
    },
    ENABLE_IMPORTANCE_IN_GOALS: {
      configuration: 'ENABLE_IMPORTANCE_IN_GOALS',
      value: 'FALSE',
    },
    DEFAULT_OBJECTIVE_VISIBILITY: {
      configuration: 'DEFAULT_OBJECTIVE_VISIBILITY',
      value: 'PUBLIC',
    },
  },
  accessControl: {
    roleToPrivilegesMap: {
      GOAL_ADMIN: {
        privileges: [
          {
            name: 'CREATE_OBJECTIVE_COMPANY',
          },
          {
            name: 'CREATE_OBJECTIVE_DEPARTMENT',
          },
          {
            name: 'CREATE_OBJECTIVE_TEAM',
          },
          {
            name: 'CREATE_OBJECTIVE_INDIVIDUAL',
          },
          {
            name: 'CREATE_GOAL_PARENT_NON_MANDATORY',
          },
          {
            name: 'CREATE_INITIATIVES',
          },
          {
            name: 'EDIT_ALL_OBJECTIVE',
          },
          {
            name: 'DELETE_ALL_OBJECTIVE',
          },
          {
            name: 'UPDATE_ALL_OBJECTIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_OBJECTIVES',
          },
          {
            name: 'EDIT_ALL_KEY_RESULT',
          },
          {
            name: 'DELETE_ALL_KEY_RESULT',
          },
          {
            name: 'UPDATE_ALL_KEY_RESULT_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_KEY_RESULTS',
          },
          {
            name: 'EDIT_ALL_INITIATIVE',
          },
          {
            name: 'DELETE_ALL_INITIATIVE',
          },
          {
            name: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_INITIATIVES',
          },
          {
            name: 'VIEW_INDIVIDUAL_INSIGHTS',
          },
          {
            name: 'DOWNLOAD_INDIVIDUAL_INSIGHTS',
          },
          {
            name: 'VIEW_OBJECTIVE_LEVEL_INSIGHTS',
          },
          {
            name: 'DOWNLOAD_OBJECTIVE_LEVEL_INSIGHTS',
          },
          {
            name: 'BULK_UPLOAD_OBJECTIVES',
          },
          {
            name: 'BULK_UPLOAD_KEY_RESULTS',
          },
          {
            name: 'BULK_UPLOAD_INITIATIVES',
          },
        ],
      },
      MANAGER: {
        privileges: [
          {
            name: 'CREATE_OBJECTIVE_DEPARTMENT',
          },
          {
            name: 'CREATE_OBJECTIVE_TEAM',
          },
          {
            name: 'CREATE_OBJECTIVE_INDIVIDUAL',
          },
          {
            name: 'CREATE_GOAL_PARENT_MANDATORY',
          },
          {
            name: 'CREATE_INITIATIVES',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_OBJECTIVES',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_KEY_RESULTS',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_INITIATIVES',
          },
          {
            name: 'VIEW_INDIVIDUAL_INSIGHTS',
          },
          {
            name: 'DOWNLOAD_INDIVIDUAL_INSIGHTS',
          },
          {
            name: 'VIEW_OBJECTIVE_LEVEL_INSIGHTS',
          },
          {
            name: 'DOWNLOAD_OBJECTIVE_LEVEL_INSIGHTS',
          },
        ],
      },
      GOAL_USER: {
        privileges: [
          {
            name: 'CREATE_OBJECTIVE_TEAM',
          },
          {
            name: 'CREATE_OBJECTIVE_INDIVIDUAL',
          },
          {
            name: 'CREATE_GOAL_PARENT_MANDATORY',
          },
          {
            name: 'CREATE_INITIATIVES',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_OBJECTIVES',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_KEY_RESULTS',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_INITIATIVES',
          },
        ],
      },
      GOAL_CUSTOM_ADMIN: {
        privileges: [
          {
            name: 'CREATE_OBJECTIVE_COMPANY',
          },
          {
            name: 'CREATE_OBJECTIVE_DEPARTMENT',
          },
          {
            name: 'CREATE_OBJECTIVE_TEAM',
          },
          {
            name: 'CREATE_OBJECTIVE_INDIVIDUAL',
          },
          {
            name: 'CREATE_GOAL_PARENT_NON_MANDATORY',
          },
          {
            name: 'CREATE_INITIATIVES',
          },
          {
            name: 'EDIT_ALL_OBJECTIVE',
          },
          {
            name: 'DELETE_ALL_OBJECTIVE',
          },
          {
            name: 'UPDATE_ALL_OBJECTIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_OBJECTIVES',
          },
          {
            name: 'EDIT_ALL_KEY_RESULT',
          },
          {
            name: 'DELETE_ALL_KEY_RESULT',
          },
          {
            name: 'UPDATE_ALL_KEY_RESULT_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_KEY_RESULTS',
          },
          {
            name: 'EDIT_ALL_INITIATIVE',
          },
          {
            name: 'DELETE_ALL_INITIATIVE',
          },
          {
            name: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_INITIATIVES',
          },
          {
            name: 'VIEW_INDIVIDUAL_INSIGHTS',
          },
          {
            name: 'DOWNLOAD_INDIVIDUAL_INSIGHTS',
          },
          {
            name: 'VIEW_OBJECTIVE_LEVEL_INSIGHTS',
          },
          {
            name: 'DOWNLOAD_OBJECTIVE_LEVEL_INSIGHTS',
          },
          {
            name: 'BULK_UPLOAD_OBJECTIVES',
          },
          {
            name: 'BULK_UPLOAD_KEY_RESULTS',
          },
        ],
      },
      OWNER: {
        privileges: [
          {
            name: 'UPDATE_ALL_OBJECTIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_OBJECTIVES',
          },
          {
            name: 'UPDATE_ALL_KEY_RESULT_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_KEY_RESULTS',
          },
          {
            name: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
          },
          {
            name: 'EDIT_ALL_INITIATIVE',
          },
          {
            name: 'DELETE_ALL_INITIATIVE',
          },
          {
            name: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_INITIATIVES',
          },
        ],
      },
      COLLABORATOR: {
        privileges: [
          {
            name: 'UPDATE_PUBLIC_OBJECTIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_OBJECTIVES',
          },
          {
            name: 'UPDATE_PUBLIC_KEY_RESULT_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_KEY_RESULTS',
          },
          {
            name: 'EDIT_ALL_INITIATIVE',
          },
          {
            name: 'DELETE_ALL_INITIATIVE',
          },
          {
            name: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_INITIATIVES',
          },
        ],
      },
      OWNER_MANAGER: {
        privileges: [
          {
            name: 'EDIT_ALL_OBJECTIVE',
          },
          {
            name: 'DELETE_ALL_OBJECTIVE',
          },
          {
            name: 'UPDATE_ALL_OBJECTIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_OBJECTIVES',
          },
          {
            name: 'EDIT_ALL_KEY_RESULT',
          },
          {
            name: 'DELETE_ALL_KEY_RESULT',
          },
          {
            name: 'UPDATE_ALL_KEY_RESULT_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_KEY_RESULTS',
          },
          {
            name: 'EDIT_ALL_INITIATIVE',
          },
          {
            name: 'DELETE_ALL_INITIATIVE',
          },
          {
            name: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_INITIATIVES',
          },
        ],
      },
      COLLABORATOR_MANAGER: {
        privileges: [
          {
            name: 'EDIT_ALL_OBJECTIVE',
          },
          {
            name: 'DELETE_ALL_OBJECTIVE',
          },
          {
            name: 'UPDATE_ALL_OBJECTIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_OBJECTIVES',
          },
          {
            name: 'EDIT_ALL_KEY_RESULT',
          },
          {
            name: 'DELETE_ALL_KEY_RESULT',
          },
          {
            name: 'UPDATE_ALL_KEY_RESULT_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_KEY_RESULTS',
          },
          {
            name: 'EDIT_ALL_INITIATIVE',
          },
          {
            name: 'DELETE_ALL_INITIATIVE',
          },
          {
            name: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_INITIATIVES',
          },
        ],
      },
      CREATOR: {
        privileges: [
          {
            name: 'VIEW_COMMENT_PUBLIC_OBJECTIVES',
          },
          {
            name: 'VIEW_COMMENT_PUBLIC_KEY_RESULTS',
          },
          {
            name: 'EDIT_ALL_INITIATIVE',
          },
          {
            name: 'DELETE_ALL_INITIATIVE',
          },
          {
            name: 'UPDATE_ALL_INITIATIVE_STATUS_PROGRESS',
          },
          {
            name: 'VIEW_COMMENT_ALL_INITIATIVES',
          },
        ],
      },
    },
  },
  selected: false,
};
